import React, { useEffect, useState } from "react";
import {api} from "../Login/axiosConfig"; // ✅ use your configured axios instance
import {
  Box,
  Typography,
  Card,
  CardMedia,
  Button,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import { useAuth } from "../../AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const SessionSlider = () => {
  const [sessions, setSessions] = useState([]);
  const navigate = useNavigate();
  const { loggedIn } = useAuth();

  useEffect(() => {
    const fetchTopSessions = async () => {
  try {
    // Get token from your auth context or localStorage
    const token = localStorage.getItem('access_token') || 
                  localStorage.getItem('auth_token');
    
    const response = await api.get(
      `${API_URL}/api/sessions/top-recent/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,  // or `Token ${token}` for DRF
        },
      }
    );
    setSessions(response.data || []);
  } catch (error) {
    console.error("Failed to fetch top sessions", error);
    setSessions([]);
  }
};

    fetchTopSessions();
  }, []);

//   useEffect(() => {
//   const dummySessions = [
//     {
//       id: 1,
//       title: "Live React Masterclass",
//       description: "Build modern React apps with hooks.",
//       media_type: "video",
//       media_url: "https://www.w3schools.com/html/mov_bbb.mp4",
//       is_bundle: false,
//     },
//     {
//       id: 2,
//       title: "Machine Learning Live Session",
//       description: "Understand ML algorithms with live coding.",
//       media_type: "image",
//       media_url: "https://images.unsplash.com/photo-1677442136019-21780ecad995",
//       is_bundle: false,
//     },
//     {
//       id: 3,
//       title: "System Design Deep Dive",
//       description: "Learn scalable architecture.",
//       media_type: "image",
//       media_url: "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
//       is_bundle: false,
//     },
//     {
//       id: 4,
//       title: "DSA Crash Course",
//       description: "Master coding interviews.",
//       media_type: "video",
//       media_url: "https://www.w3schools.com/html/movie.mp4",
//       is_bundle: false,
//     },
//   ];

//   setSessions(dummySessions);
// }, []);
  const handleCardClick = (card) => {
    const isBundle = card.is_bundle;

    const destinationPath = isBundle
      ? `/bundle-detail/${card.id}`
      : `/post-tab-details/${card.id}`;

    const fullPathWithQuery = `${destinationPath}?isBundle=${isBundle}`;

    const linkTo = loggedIn
      ? fullPathWithQuery
      : `/login?redirect=${encodeURIComponent(fullPathWithQuery)}`;

    navigate(linkTo);
  };

  // 🔹 Guard: don’t render Swiper until data is ready
  if (!sessions.length) return null;

  return (
    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      loop
      speed={1200}
      autoplay={{
        delay: 5000,               // auto change slide
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      }}
      style={{ width: "100%", height: "70vh" }}
    >
      {sessions.map((card) => (
        <SwiperSlide key={card.id}>
          <Card
            sx={{
              position: "relative",
              height: "70vh",
              borderRadius: 0,
              overflow: "hidden",
              cursor: "pointer",
            }}
            onClick={() => handleCardClick(card)}
          >
            {/* Background media */}
            {card.media_type === "video" ? (
  <CardMedia
    component="video"
    src={card.media_url}
    autoPlay
    muted
    loop
    playsInline
    preload="metadata"
    sx={{ height: "100%", width: "100%", objectFit: "cover" }}
  />
) : (
  <CardMedia
    component="img"
    image={card.media_url}
    sx={{ height: "100%", width: "100%", objectFit: "cover" }}
  />
)}

            {/* Gradient overlay */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(90deg, rgba(0,0,0,0.85) 20%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0) 100%)",
              }}
            />

            {/* Content */}
<Box
  sx={{
    position: "absolute",
    bottom: { xs: "8%", sm: "12%", md: "18%" },
    left: { xs: "5%", sm: "8%", md: "10%" },
    maxWidth: { xs: "90%", sm: "70%", md: "45%" },
    color: "#fff",
  }}
>
  <Typography
    variant="h3"
    sx={{
      fontWeight: 800,
      mb: { xs: 1.5, md: 2 },
      lineHeight: 1.1,
      fontSize: {
        xs: "1.8rem",
        sm: "2.4rem",
        md: "3rem",
      },
    }}
  >
    {card.title}
  </Typography>

  {card.description && (
    <Typography
      variant="body1"
      sx={{
        opacity: 0.85,
        mb: { xs: 2, md: 3 },
        fontSize: {
          xs: "0.9rem",
          sm: "1rem",
        },
      }}
    >
      {card.description.slice(0, 150)}…
    </Typography>
  )}

  <Button
    variant="contained"
    size="large"
    sx={{
      bgcolor: "#fff",
      color: "#000",
      fontWeight: 600,
      px: { xs: 2.5, sm: 4 },
      py: { xs: 1, sm: 1.25 },
      fontSize: { xs: "0.85rem", sm: "1rem" },
      "&:hover": { bgcolor: "#e6e6e6" },
    }}
  >
    ▶ View Session
  </Button>
</Box>

          </Card>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SessionSlider;
